declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

const PIXEL_ID = '1773283600047632'

export const initMetaPixel = () => {
  if (typeof window === 'undefined') return
  if (window.fbq) return // already initialized

  // Set up the fbq stub function before the script loads
  const f: any = window
  const n: any = function () {
    n.callMethod
      ? // eslint-disable-next-line prefer-rest-params
        n.callMethod.apply(n, arguments)
      : // eslint-disable-next-line prefer-rest-params
        n.queue.push(arguments)
  }
  f.fbq = n
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Inject the script — safely handle cases where no <script> tag exists yet
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')

  // <noscript> fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

export const fireAddToCart = (data?: {
  value?: number
  currency?: string
  content_name?: string
}) => {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'AddToCart', {
    value: data?.value ?? 6.36,
    currency: data?.currency ?? 'USD',
    content_name:
      data?.content_name ??
      'El Gran Manual de Preparaciones Medicinales Naturales',
  })
}
